export class KycToken {
  hasValue = !!this.value;
  shouldSkipKyc = this.value === 'skip';

  constructor(readonly value?: string) {}
}
